import { FC } from 'react';

import { useTranslations } from 'context/translations';
import { LandingPageTextKeys } from 'service';
import { LandingPageContentKeys } from 'service/contentful/keys';

import styles from './DoctorsBlock.module.css';

export const DoctorsBlock: FC = () => {
  const { t, content } = useTranslations();

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>
        {t(LandingPageTextKeys.DoctorsBlockTitle)}
      </h1>
      <div className={styles.scroll_container}>
        <div className={styles.doctors_container}>
          {content(LandingPageContentKeys.DoctorsBlockContent).map(
            ({ imageUrl, text, title }) => (
              <div className={styles.doctor_card} key={text}>
                <img
                  className={styles.doctor_image}
                  src={imageUrl}
                  alt="doctor"
                  loading="lazy"
                />
                <div>
                  <strong>{text}</strong>
                  <div>{title}</div>
                </div>
              </div>
            ),
          )}
          <span className={styles.doctor_card}>
            {t(LandingPageTextKeys.DoctorsBlockLabel)}
          </span>
        </div>
      </div>
    </div>
  );
};
